import { render, staticRenderFns } from "./accountSwitch.vue?vue&type=template&id=ba356898&scoped=true&"
import script from "./accountSwitch.vue?vue&type=script&lang=js&"
export * from "./accountSwitch.vue?vue&type=script&lang=js&"
import style0 from "./accountSwitch.vue?vue&type=style&index=0&id=ba356898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba356898",
  null
  
)

export default component.exports